import React from 'react';
import { createStore } from 'redux';
import { Provider } from 'react-redux';

import rootReducer from './reducers';

export const ReduxProvider = async () => {

  const awaitedRootReducer = await rootReducer

  return ({
    children,
    defaultLanguage,
    hasMulitLanguage,
    routeMappingObj,
    appConfiguration,
    appMode,
    appRegion,
    appEnv,
    errorUrl,
  }) => {
    const initialState = {
      routePathing: {
        defaultLang: defaultLanguage,
        hasMultiLang: hasMulitLanguage,
      },
      appRegion,
      appMode,
      appEnv,
      routePathMapping: routeMappingObj,
      Config: appConfiguration,
      errorUrl,
    };
  
    const store = createStore(awaitedRootReducer, initialState);
  
    return <Provider store={store}>{children}</Provider>;
  };
}

export default ReduxProvider;